<ion-app>
  <app-side-menu *ngIf="utilService.isStoneCreek()"></app-side-menu>
  <ion-router-outlet id="main"></ion-router-outlet>
</ion-app>
